import { FlexBox } from '@ardoq/layout';
import { Text } from '@ardoq/typography';
import { EmptyFilterResultProps } from './PropTypes';

export const EmptyFilterResult = ({ message }: EmptyFilterResultProps) => (
  <FlexBox justify="center" align="center" padding="large" height="full">
    <Text color="textSubtle" align="center">
      {message}
    </Text>
  </FlexBox>
);
